// client/globals/consumer.ts
import { ContextConsumer, createContext } from "@lit/context";
import { Contexts } from "./enums.js";
var DocumentExtensionsConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.DOCUMENT_EXTENSION),
    subscribe
  });
};
var ExtensionsConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.EXTENSIONS),
    subscribe
  });
};
var ContentConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.CONTENT),
    subscribe
  });
};
var PreviewConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.PREVIEW),
    subscribe
  });
};
var EditContentConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.EDIT_CONTENT),
    subscribe
  });
};
var DraggingConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.DRAGGING),
    subscribe
  });
};
var ClipboardConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.CLIPBOARD),
    subscribe
  });
};
var SizeConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.SIZE),
    subscribe
  });
};
var HideCustomComponentIDConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.HIDE_CUSTOM_COMPONENT_ID),
    subscribe
  });
};
var IsEditorConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.IS_EDITOR),
    subscribe
  });
};
var SizeBreakpointConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.SIZE_BREAKPOINT),
    subscribe
  });
};
var IdentifierConsumer = (host, subscribe) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.IDENTIFIER),
    subscribe
  });
};
var FormConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.FORM),
    subscribe
  });
};
var ModeConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.MODE),
    subscribe
  });
};
var OptionsConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.OPTIONS),
    subscribe
  });
};
var AutoScrollContainerConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.AUTO_SCROLL_CONTAINER),
    subscribe
  });
};
var CustomContentConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.CUSTOM_CONTENT),
    subscribe
  });
};
var GlobalSettingsClassNameConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.GLOBAL_SETTINGS_CLASS_NAME),
    subscribe
  });
};
var AnchorIDConsumer = (host, subscribe = true) => {
  return new ContextConsumer(host, {
    context: createContext(Contexts.ANCHOR_ID),
    subscribe
  });
};
export {
  AnchorIDConsumer,
  AutoScrollContainerConsumer,
  ClipboardConsumer,
  ContentConsumer,
  CustomContentConsumer,
  DocumentExtensionsConsumer,
  DraggingConsumer,
  EditContentConsumer,
  ExtensionsConsumer,
  FormConsumer,
  GlobalSettingsClassNameConsumer,
  HideCustomComponentIDConsumer,
  IdentifierConsumer,
  IsEditorConsumer,
  ModeConsumer,
  OptionsConsumer,
  PreviewConsumer,
  SizeBreakpointConsumer,
  SizeConsumer
};
